import React, { StrictMode } from 'react';

import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { persistStore } from 'redux-persist';

import { Box, CircularProgress, ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { PostHogProvider } from '@posthog/react'
import { QueryClientProvider } from '@tanstack/react-query';
import { PersistGate } from 'redux-persist/integration/react';

import { queryClient } from '~system/query/query-client';
import { UserMetaCrossTabSync } from '~system/query/user-meta-cross-tab-sync';
import { AuthCrossTabSync } from '~system/store/auth-cross-tab-sync';
import { store } from '~system/store/configure-store';

import { GlobalIconDefs } from '~components/ui/global-icon-defs/global-icon-defs';

import { FRONTEND_CONFIG } from '~app/config';

import { theme } from '~styles/theme';

import { routerConfig } from './router/router-config';

const persistor = persistStore(store);

const postHogOptions = {
  api_host: FRONTEND_CONFIG.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
} as const;

const AppBootstrapFallback = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress size={32} />
  </Box>
);

export function App() {
  return (
    <StrictMode>
      {/*<PostHogProvider apiKey={FRONTEND_CONFIG.VITE_PUBLIC_POSTHOG_KEY} options={postHogOptions}>*/}
      <Provider store={store}>
        <PersistGate loading={<AppBootstrapFallback />} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <AuthCrossTabSync />
            <UserMetaCrossTabSync />
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="uk"
              localeText={{
                fieldDayPlaceholder: () => 'ДД',
                fieldMonthPlaceholder: () => 'ММ',
                fieldYearPlaceholder: () => 'РРРР',
                cancelButtonLabel: 'Скасувати',
                okButtonLabel: 'Підтвердити',
                todayButtonLabel: 'Сьогодні',
                clearButtonLabel: 'Очистити',
                datePickerToolbarTitle: 'Оберіть дату',
              }}
            >
              <ThemeProvider theme={theme}>
                <GlobalIconDefs />
                <RouterProvider router={routerConfig} />
              </ThemeProvider>
            </LocalizationProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
      {/*</PostHogProvider>*/}
    </StrictMode>
  );
}

export default App;
